import { isArray } from 'lodash-es';
import { isEqual } from 'lodash-es';
import { isObject } from 'lodash-es';
import { transform } from 'lodash-es';

export function differenceBetween(
  originalObject: Record<string, any>,
  newObject: Record<string, any>,
): Record<string, any> {
  const computeChanges = (current: Record<string, any>, original: Record<string, any>): Record<string, any> => {
    let arrayIndexCounter = 0;

    return transform(current, (result: Record<string, any>, value: any, key: string | number) => {
      const originalValue = original[key];
      const isBothObjects = isObject(value) && isObject(originalValue);
      const isDifferent = !isEqual(value, originalValue);

      if (isDifferent) {
        const resultKey = isArray(original) ? arrayIndexCounter++ : key;
        result[resultKey] = isBothObjects ? computeChanges(value, originalValue) : value;
      }
    });
  };

  return computeChanges(newObject, originalObject);
}
